import { API_ADD_BASES_ARCHIVE } from "../constants/constants";

export const GET_LOGIN_TOKEN = "GET_LOGIN_TOKEN";

export const SET_SEARCH_PARAMS_BOATS = "SET_SEARCH_PARAMS_BOATS";
export const SET_PAGE_INDEX_BOATS = "SET_PAGE_INDEX_BOATS";
export const GET_BOATS_CARDS_LIST = "GET_BOATS_CARDS_LIST";
export const GET_BOAT_CARD_INFO = "GET_BOAT_CARD_INFO";

// export const SET_SEARCH_PARAMS_BOATS = "SET_SEARCH_PARAMS_BOATS";
export const GET_DATA_BY_SEARCH_PARAMS_BOAT = "GET_DATA_BY_SEARCH_PARAMS_BOAT";
export const GET_PAGINATION_DATA_BY_SEARCH_PARAMS_BOAT = "GET_PAGINATION_DATA_BY_SEARCH_PARAMS_BOAT";

export const GET_DATA_BY_SEARCH_PARAMS_LICENSE = "GET_DATA_BY_SEARCH_PARAMS_LICENSE";
export const GET_LICENSE_BY_ID = "GET_LICENSE_BY_ID";
export const SET_SEARCH_PARAMS_LICENSE = "SET_SEARCH_PARAMS_LICENSE";
export const SET_PAGE_INDEX_LICENSE = "SET_PAGE_INDEX_LICENSE";
export const SET_SEARCH_PARAMS_BOATS_REG = "SET_SEARCH_PARAMS_BOATS_REG";
export const SET_SEARCH_PARAMS_REG_INFORM_CHANGES = "SET_SEARCH_PARAMS_REG_INFORM_CHANGES";
export const GET_DATA_BY_SEARCH_PARAMS_BOATS_REG = "GET_DATA_BY_SEARCH_PARAMS_BOATS_REG";

export const GET_DATA_BY_SEARCH_PARAMS_BASES_BUILDING = "GET_DATA_BY_SEARCH_PARAMS_BASES_BUILDING";
export const SET_SEARCH_PARAMS_BASES_BUILDING = "SET_SEARCH_PARAMS_BASES_BUILDING";
export const ADD_NEW_BASES = "ADD_NEW_BASES";
export const EDIT_BASES = "EDIT_BASES";
export const SET_ERROR_MESSAGE_BASES = "SET_ERROR_MESSAGE_BASES";
export const ARCHIVE_LOADING_BASES = "ARCHIVE_LOADING_BASES";
export const ARCHIVE_SUCCESS_BASES = "ARCHIVE_SUCCESS_BASES";
export const ARCHIVE_ERROR_MESSAGE_BASES = "ARCHIVE_ERROR_MESSAGE_BASES";

export const GET_DICTIONARY_GIMS_SECTIONS = "GET_DICTIONARY_GIMS_SECTIONS";
export const GET_DICTIONARY_OWNER_TYPE = "GET_DICTIONARY_OWNER_TYPE";
export const GET_DICTIONARY_NSI_CHECK_STATUS = "GET_DICTIONARY_NSI_CHECK_STATUS";
export const GET_DICTIONARY_RAYON_FOR_OBL = "GET_DICTIONARY_RAYON_FOR_OBL";
export const GET_DICTIONARY_STATUS_ISSUANCE_CERTIFICATES = "GET_DICTIONARY_STATUS_ISSUANCE_CERTIFICATES";

export const ADD_NEW_SPEC_MARK = "ADD_NEW_SPEC_MARK";
export const ADD_NEW_CONF_MARK = "ADD_NEW_CONF_MARK";
export const REVOKE_LICENSE = "REVOKE_LICENSE";
export const CLEAR_LICENSE_INFO = "CLEAR_LICENSE_INFO";

export const GET_USERS_LIBRARY = "GET_USERS_LIBRARY";
export const GET_ATE_LIBRARY = "GET_ATE_LIBRARY";
export const GET_APP_REG_STATUS_LIBRARY = "GET_APP_REG_STATUS_LIBRARY";
export const GET_TRAINING_PROGRAM_LIBRARY = "GET_TRAINING_PROGRAM_LIBRARY";
export const GET_AUDIT_OBJECT = "GET_AUDIT_OBJECT";
export const GET_VALID_ZONES_LIBRARY = "GET_VALID_ZONES_LIBRARY";
export const GET_VALID_TYPES_LIBRARY = "GET_VALID_TYPES_LIBRARY";

export const ADD_NEW_BOAT_INFO = "ADD_NEW_BOAT_INFO";
export const UPDATE_BOAT_INFO = "UPDATE_BOAT_INFO";
export const UPDATE_BOAT_INFO_FOR_ID = "UPDATE_BOAT_INFO_FOR_ID";
export const UPDATE_BOAT_INFO_FOR_ID_DEALS = "UPDATE_BOAT_INFO_FOR_ID_DEALS";
export const UPDATE_BOAT_INFO_API = "UPDATE_BOAT_INFO_API";
export const CLEAR_BOAT_INFO = "CLEAR_BOAT_INFO";
export const CHANGE_BOAT_INFO = "CHANGE_BOAT_INFO";
export const GET_CHECK_BOAT_SERIAL_NUMBER = "GET_CHECK_BOAT_SERIAL_NUMBER";
export const EDIT_BOAT_INFO = "EDIT_BOAT_INFO";
export const REMOVE_ARREST_BOAT_INFO = "REMOVE_ARREST_BOAT_INFO";
export const DELETE_BOAT_FILE = "DELETE_BOAT_FILE";

export const GET_BOATS_REG_INFO = "GET_BOATS_REG_INFO";
export const GET_BOATS_DECISION_INFO = "GET_BOATS_DECISION_INFO";

export const SET_SORT_STATE_TABLE = "SET_SORT_STATE_TABLE";

export const GET_REG_INFORM_CHANGES = "GET_REG_INFORM_CHANGES";
export const SET_SEARCH_PARAMS_BOATS_ADMIN_PROC = "SET_SEARCH_PARAMS_BOATS_ADMIN_PROC";
export const GET_REG_INFORM_CHANGES_BOAT_CARDS = "GET_REG_INFORM_CHANGES_BOAT_CARDS";

export const ADD_NEW_ENGINE_CHECK = "ADD_NEW_ENGINE_CHECK";
export const ADD_NEW_SPEC_MARK_APP = "ADD_NEW_SPEC_MARK_APP";
export const DELETE_NEW_NOTE_APP = "DELETE_NEW_NOTE_APP";
export const ADD_NEW_DEAL = "ADD_NEW_DEAL";
export const ADD_NEW_STATEMENT_DATA = "ADD_NEW_STATEMENT_DATA";
export const SET_DATA_FOR_STATEMENT_TABLES = "SET_DATA_FOR_STATEMENT_TABLES";
export const ADD_NEW_STATEMENT = "ADD_NEW_STATEMENT";
export const CLEAR_NEW_STATEMENT = "CLEAR_NEW_STATEMENT";
export const CLEAR_DECISION_DATA = "CLEAR_DECISION_DATA";
export const ADD_NEW_ENGINE_CHECK_STATIC = "ADD_NEW_ENGINE_CHECK_STATIC";
export const CLEAR_ENGINES_TABLE = "CLEAR_ENGINES_TABLE";

export const SET_SEARCH_PARAMS_DUP_SHIP_TICKET = "SET_SEARCH_PARAMS_DUP_SHIP_TICKET";
export const SET_SEARCH_PARAMS_BOATS_DUP_SHIP_TICKET = "SET_SEARCH_PARAMS_BOATS_DUP_SHIP_TICKET";
export const GET_DUP_SHIP_TICKET_INFO = "GET_DUP_SHIP_TICKET_INFO";
export const GET_BOAT_CARD_FOR_DUPLICATE = "GET_BOAT_CARD_FOR_DUPLICATE";
export const ADD_DATA_FOR_DUPLICATE = "ADD_DATA_FOR_DUPLICATE";
export const GET_DUPLICATE_DECISION_INFO = "GET_DUPLICATE_DECISION_INFO";
export const SET_SEARCH_PARAMS_BOATS_DUPLICATE_TICKETS = "SET_SEARCH_PARAMS_BOATS_DUPLICATE_TICKETS";
export const GET_DUPLICATE_BOAT_CARDS = "GET_DUPLICATE_BOAT_CARDS";
export const CLEAR_DUPLICATE_TICKET_DATA = "CLEAR_DUPLICATE_TICKET_DATA";

// export const GET_DUP_SHIP_TICKET_BOAT_CARDS = "GET_DUP_SHIP_TICKET_BOAT_CARDS";

export const SET_SEARCH_PARAMS_SHIPS_TICKET = "SET_SEARCH_PARAMS_SHIPS_TICKET";
export const GET_SHIPS_TICKET_INFO = "GET_SHIPS_TICKET_INFO";
export const GET_SHIPS_TICKET_DECISION_INFO = "GET_SHIPS_TICKET_DECISION_INFO";

export const SET_SEARCH_PARAMS_PROVISION_INFORMATION = "SET_SEARCH_PARAMS_PROVISION_INFORMATION";
export const GET_DATA_BY_PARAMS_PROVISION_INFORMATION = "GET_DATA_BY_PARAMS_PROVISION_INFORMATION";

export const SET_SEARCH_PARAMS_TRANSPORT_ACCIDENTS = "SET_SEARCH_PARAMS_TRANSPORT_ACCIDENTS";
export const GET_DATA_BY_SEARCH_PARAMS_TRANSPORT_ACCIDENTS = "GET_DATA_BY_SEARCH_PARAMS_TRANSPORT_ACCIDENTS";
export const ADD_NEW_CULPRIT = "ADD_NEW_CULPRIT";
export const ADD_NEW_INJURED = "ADD_NEW_INJURED";
export const DELETE_NEW_NOTE_ACCIDENT = "DELETE_NEW_NOTE_ACCIDENT";
export const ADD_NEW_ACCIDENT_DATA = "ADD_NEW_ACCIDENT_DATA";
export const CLEAR_ACCIDENT_DATA = "CLEAR_ACCIDENT_DATA";
export const GET_BOAT_INFO_BY_REGNUM = "GET_BOAT_INFO_BY_REGNUM";
export const SET_BOAT_INFO_BY_REGNUM_STATUS = "SET_BOAT_INFO_BY_REGNUM_STATUS";
export const GET_TRANSPORT_ACCIDENT_INFO = "GET_TRANSPORT_ACCIDENT_INFO";
export const SAVE_TRANSPORT_ACCIDENT_MAIN_INFO = "SAVE_TRANSPORT_ACCIDENT_MAIN_INFO";
export const SET_ERROR_TRANSPORT_ACCIDENT = "SET_ERROR_TRANSPORT_ACCIDENT";
export const SET_ERROR_TERMINATION_CASE = "SET_ERROR_TERMINATION_CASE";

export const DELETE_ACCIDENT_FILE = "DELETE_ACCIDENT_FILE";

export const SET_SEARCH_PARAMS_TECH_EXAM = "SET_SEARCH_PARAMS_TECH_EXAM";
export const GET_DATA_BY_SEARCH_PARAMS_TECH_EXAM = "GET_DATA_BY_SEARCH_PARAMS_TECH_EXAM";
export const SET_SEARCH_PARAMS_BOATS_TECH_EXAM = "SET_SEARCH_PARAMS_BOATS_TECH_EXAM";
export const GET_TECH_EXAM_BOAT_CARDS = "GET_TECH_EXAM_BOAT_CARDS";
export const GET_BOAT_CARD_FOR_TECH_EXAM = "GET_BOAT_CARD_FOR_TECH_EXAM";
export const ADD_NEW_TECH_EXAM_TABLE_INFO = "ADD_NEW_TECH_EXAM_TABLE_INFO";
export const ADD_NEW_TECH_EXAM_DATA = "ADD_NEW_TECH_EXAM_DATA";
export const DELETE_NEW_TECH_EXAM_TABLE_INFO = "DELETE_NEW_TECH_EXAM_TABLE_INFO";
export const GET_APP_DATA_FOR_EDIT_TECH_EXAM = "GET_APP_DATA_FOR_EDIT_TECH_EXAM";
export const CLEAR_APP_DATA_TECH_EXAM = "CLEAR_APP_DATA_TECH_EXAM";

export const SET_SEARCH_PARAMS_APPLICATION_TRAINING = "SET_SEARCH_PARAMS_APPLICATION_TRAINING";
export const GET_DATA_BY_SEARCH_PARAMS_APPLICATION_TRAINING =
  "GET_DATA_BY_SEARCH_PARAMS_APPLICATION_TRAINING";

export const SET_SORT_STATE_EDITABLE_TABLE = "SET_SORT_STATE_EDITABLE_TABLE";
export const SET_SEARCH_PARAMS_EXPULSION_ORDER = "SET_SEARCH_PARAMS_EXPULSION_ORDER";
export const GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER = "GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER";

export const SET_DATA_FOR_VIEW_EXPULSION_ORDER = "SET_DATA_FOR_VIEW_EXPULSION_ORDER";
export const UPDATE_SEARCH_CARD_EXPULSION_ORDER = "UPDATE_SEARCH_CARD_EXPULSION_ORDER";
export const UPDATE_EDITABLE_TABLE_DATA_EXPULSION_ORDER = "UPDATE_EDITABLE_TABLE_DATA_EXPULSION_ORDER";
export const UPDATE_SEARCH_CARD_ORDER_NUM = "UPDATE_SEARCH_CARD_ORDER_NUM";
export const ADD_LISTENER_EXPULSION_ORDER_TABLE = "ADD_LISTENER_EXPULSION_ORDER_TABLE";
export const CLEAR_STATE_EXPULSION_ORDER = "CLEAR_STATE_EXPULSION_ORDER";

export const SET_SEARCH_PARAMS_SEARCH_LISTENER = "SET_SEARCH_PARAMS_SEARCH_LISTENER";
export const GET_DATA_BY_SEARCH_PARAMS_SEARCH_LISTENER = "GET_DATA_BY_SEARCH_PARAMS_SEARCH_LISTENER";
export const UPDATE_EDITABLE_TABLE_DATA_SEARCH_LISTENER = "UPDATE_EDITABLE_TABLE_DATA_SEARCH_LISTENER";

export const SET_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK = "SET_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK";
export const GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK =
  "GET_DATA_BY_SEARCH_PARAMS_EXPULSION_ORDER_LOGBOOK";
export const GET_ALL_EXPULSION_ORDER_LOGBOOK = "GET_ALL_EXPULSION_ORDER_LOGBOOK";

export const SET_SEARCH_PARAMS_RECORD_TRAINED_USERS = "SET_SEARCH_PARAMS_RECORD_TRAINED_USERS";
export const GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS =
  "GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS";

export const SET_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK =
  "SET_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK";
export const GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK =
  "GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK";
export const GET_DATA_PAGINATION_RECORD_TRAINED_USERS_LOGBOOK =
  "GET_DATA_PAGINATION_RECORD_TRAINED_USERS_LOGBOOK";

export const SET_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION = "SET_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION";
export const GET_DATA_BY_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION =
  "GET_DATA_BY_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION";
export const ADD_NEW_DATA_APP_KNOWLEDGE_VERIFICATION = "ADD_NEW_DATA_APP_KNOWLEDGE_VERIFICATION";
export const SAVE_APP_KNOWLEDGE_VERIFICATION = "SAVE_APP_KNOWLEDGE_VERIFICATION";
export const GET_DATA_APP_KNOWLEDGE_VERIFICATION_BY_ID = "GET_DATA_APP_KNOWLEDGE_VERIFICATION_BY_ID";
export const CLEAR_STATE_KNOWLEDGE_VERIFICATION = "CLEAR_STATE_KNOWLEDGE_VERIFICATION";
export const GET_DATA_BY_INPUT_INFO_KNOWLEDGE_VERIFICATION = "GET_DATA_BY_INPUT_INFO_KNOWLEDGE_VERIFICATION";
export const SAVE_DATA_FOR_RERENDER_KNOWLEDGE_VERIFICATION = "SAVE_DATA_FOR_RERENDER_KNOWLEDGE_VERIFICATION";
export const SET_NEED_REWRITE = "SET_NEED_REWRITE";
export const CLEAR_ERROR_APP_KNOWLEDGE_VERIFICATION = "CLEAR_ERROR_APP_KNOWLEDGE_VERIFICATION";

export const SET_SEARCH_PARAMS_ISSUING_CERTIFICATES = "SET_SEARCH_PARAMS_ISSUING_CERTIFICATES";
export const SET_SEARCH_PARAMS_APPLICANT_SEARCH = "SET_SEARCH_PARAMS_APPLICANT_SEARCH";
export const GET_DATA_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES =
  "GET_DATA_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES";

export const GET_DATA_APPLICANT_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES =
  "GET_DATA_APPLICANT_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES";

export const SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD = "SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD";
export const GET_DATA_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD =
  "GET_DATA_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD";
export const SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD_SEARCH_PEOPLE =
  "SET_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD_SEARCH_PEOPLE";
export const GET_DATA_PEOPLE_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD =
  "GET_DATA_PEOPLE_BY_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD";
export const UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD = "UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD";
export const UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD = "UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD";
export const UPDATE_DATA_PEOPLE_TABLE_KNOWELEDGE_TEST_RECORD =
  "UPDATE_DATA_PEOPLE_TABLE_KNOWELEDGE_TEST_RECORD";
export const ADD_DATA_TABLE_KNOWELEDGE_TEST_RECORD = "ADD_DATA_TABLE_KNOWELEDGE_TEST_RECORD";
export const UPDATE_EDITABLE_TABLE_DATA_KNOWELEDGE_TEST_RECORD =
  "UPDATE_EDITABLE_TABLE_DATA_KNOWELEDGE_TEST_RECORD";
export const CLEAR_STATE_KNOWELEDGE_TEST_RECORD = "CLEAR_STATE_KNOWELEDGE_TEST_RECORD";
export const SET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD = "SET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD";

export const ADD_NEW_DATA_ISSUING_CERTIFICATES = "ADD_NEW_DATA_ISSUING_CERTIFICATES";
export const GET_APPLICANT_INFO_BY_ID = "GET_APPLICANT_INFO_BY_ID";
export const GET_ISSUING_APP_BY_ID = "GET_ISSUING_APP_BY_ID";
export const CLEAR_ISSUING_APP_DATA = "CLEAR_ISSUING_APP_DATA";

export const SET_SEARCH_PARAMS_PRINT_CERTIFICATES = "SET_SEARCH_PARAMS_PRINT_CERTIFICATES";
export const GET_DATA_BY_SEARCH_PARAMS_PRINT_CERTIFICATES = "GET_DATA_BY_SEARCH_PARAMS_PRINT_CERTIFICATES";
export const UPDATE_SEARCH_DATA_PRINT_CERTIFICATES = "UPDATE_SEARCH_DATA_PRINT_CERTIFICATES";

export const SET_LOGIN_STATUS = "SET_LOGIN_STATUS";
export const AUTHORIZATION_LOGIN_SUCCESS = "AUTHORIZATION_LOGIN_SUCCESS";
export const AUTHORIZATION_LOGIN_FAILURE = "AUTHORIZATION_LOGIN_FAILURE";
export const AUTHORIZATION_LOGOUT_SUCCESS = "AUTHORIZATION_LOGOUT_SUCCESS";
export const FIRST_LOGIN_SUCCESS = "FIRST_LOGIN_SUCCESS";
export const FIRST_LOGIN_FAILURE = "FIRST_LOGIN_FAILURE";

export const REFRESH_ACCESS_TOKEN = "REFRESH_ACCESS_TOKEN";
export const REFRESH_REFRESH_TOKEN = "REFRESH_REFRESH_TOKEN";
export const REFRESH_REFRESH_TOKEN_ERROR = "REFRESH_REFRESH_TOKEN_ERROR";
export const CHECK_ACCESS_TOKEN = "CHECK_ACCESS_TOKEN";

export const SET_INSPECTION_TECHNICAL_CONDITION_BASES = "SET_INSPECTION_TECHNICAL_CONDITION_BASES";
export const GET_INSPECTION_TECHNICAL_CONDITION_BASES = "GET_INSPECTION_TECHNICAL_CONDITION_BASES";
export const GET_INSPECTION_TECHNICAL_CONDITION_BASES_ALL = "GET_INSPECTION_TECHNICAL_CONDITION_BASES_ALL";

export const SET_SEARCH_PARAMS_EXCHANGE_CERTIFICATES = "SET_SEARCH_PARAMS_EXCHANGE_CERTIFICATES";
export const GET_DATA_BY_SEARCH_PARAMS_EXCHANGE_CERTIFICATES =
  "GET_DATA_BY_SEARCH_PARAMS_EXCHANGE_CERTIFICATES";
export const GET_CERTIFICATE_INFO_BY_NUM = "GET_CERTIFICATE_INFO_BY_NUM";
export const ADD_NEW_DATA_EXCHANGE_CERTIFICATES = "ADD_NEW_DATA_EXCHANGE_CERTIFICATES";
export const GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE = "GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE";
export const CLEAR_EXCHANGE_APP_DATA = "CLEAR_EXCHANGE_APP_DATA";
export const GET_EXCHANGE_APP_BY_ID = "GET_EXCHANGE_APP_BY_ID";

export const SET_SEARCH_PARAMS_DUPLICATE_CERTIFICATES = "SET_SEARCH_PARAMS_DUPLICATE_CERTIFICATES";
export const GET_DATA_BY_SEARCH_PARAMS_DUPLICATE_CERTIFICATES =
  "GET_DATA_BY_SEARCH_PARAMS_DUPLICATE_CERTIFICATES";
export const GET_CERTIFICATE_INFO_BY_NUM_DUPLICATE = "GET_CERTIFICATE_INFO_BY_NUM_DUPLICATE";
export const CLEAR_DUPLICATE_APP_DATA = "CLEAR_EXCHANGE_APP_DATA";
export const GET_DUPLICATE_APP_BY_ID = "GET_DUPLICATE_APP_BY_ID";

export const GET_INSPECTION_TECHNICAL_CONDITION_BASE = "GET_INSPECTION_TECHNICAL_CONDITION_BASE";

export const NEW_GET_DICTIONARY_NSI_CHECK_STATUS = "NEW_GET_DICTIONARY_NSI_CHECK_STATUS";

export const SET_EXAMINATION_RESULT_FILE = "SET_EXAMINATION_RESULT_FILE";

export const RESET_EXAMINATION_RESULT_FILE = "RESET_EXAMINATION_RESULT_FILE";

export const GET_NSI_AP = "GET_NSI_AP";
export const GET_ALL_BILL_STATUS = "GET_ALL_BILL_STATUS";
export const GET_ALL_PAID_PROC_TYPES = "GET_ALL_PAID_PROC_TYPES";
export const GET_ALL_INF_PAYMENT_AP = "GET_ALL_INF_PAYMENT_AP";

export const SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES = "SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES";

export const SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_DATA = "SET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_DATA";
export const UPDATE_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES = "UPDATE_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES";
export const CLEAR_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES = "CLEAR_DATA_LOGBOOK_ADMINISTRATIVE_PROCEDURES";

export const GET_GIMS_DEPARTMENT_ALL = "GET_GIMS_DEPARTMENT_ALL";
export const GET_GIMS_DEPARTMENT = "GET_GIMS_DEPARTMENT";

export const GET_GIMS_SECTIONS_SEARCH = "GET_GIMS_SECTIONS_SEARCH";
export const GET_GIMS_SECTION = "GET_GIMS_SECTION";
export const SAVE_GIMS_SECTION_ERROR = "SAVE_GIMS_SECTION_ERROR";
export const SAVE_GIMS_SECTION_NO_ERROR = "SAVE_GIMS_SECTION_NO_ERROR";
export const CLEAR_GIMS_SECTION = "CLEAR_GIMS_SECTION";
export const SET_SEARCH_PARAMS_GIMS_SECTIONS = "SET_SEARCH_PARAMS_GIMS_SECTIONS";

export const GET_ADMINISTRATIVE_DISTRICTS_ALL = "GET_ADMINISTRATIVE_DISTRICTS_ALL";
export const GET_ADMINISTRATIVE_DISTRICTS = "GET_ADMINISTRATIVE_DISTRICTS";
export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";
export const GET_ALL_TRAINING_ORGANIZATIONS = "GET_ALL_TRAINING_ORGANIZATIONS";
export const GET_ALL_OBLAST = "GET_ALL_OBLAST";
export const GET_RAYON_BY_OBLAST = "GET_RAYON_BY_OBLAST";
export const GET_GIMS_USER_POSITIONS_ALL = "GET_GIMS_USER_POSITIONS_ALL";
export const GET_GIMS_USER_POSITION = "GET_GIMS_USER_POSITION";
export const GET_SWIMMING_DIFFICULTY_CATEGORY_ALL = "GET_SWIMMING_DIFFICULTY_CATEGORY_ALL";
export const GET_SWIMMING_DIFFICULTY_CATEGORY = "GET_SWIMMING_DIFFICULTY_CATEGORY";
export const GET_PREPARATION_PROGRAMS_ALL = "GET_PREPARATION_PROGRAMS_ALL";
export const GET_RANGE_MS_ALL = "GET_RANGE_MS_ALL";
export const GET_PREPARATION_PROGRAM = "GET_PREPARATION_PROGRAM";
export const GET_RANGE_MS_BY_ID = "GET_RANGE_MS_BY_ID";
export const GET_PAYMENT_DETAILS_ALL = "GET_PAYMENT_DETAILS_ALL";
export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS";
export const GET_SETTLEMENTS = "GET_SETTLEMENTS";
export const SET_SEARCH_PARAMS_SETTLEMENTS = "SET_SEARCH_PARAMS_SETTLEMENTS";
export const GET_RAYON_BY_OBLAST_SETTLEMENTS = "GET_RAYON_BY_OBLAST_SETTLEMENTS";
export const GET_SETTLEMENT = "GET_SETTLEMENT";
export const RESET_SETTLEMENT = "RESET_SETTLEMENT";
export const GET_SETTLEMENTS_ERROR = "GET_SETTLEMENTS_ERROR";
export const GET_SETTLEMENTS_NO_ERROR = "GET_SETTLEMENTS_NO_ERROR";
export const CHANGE_SETTLEMENTS_IS_SAVE = "CHANGE_SETTLEMENTS_IS_SAVE";
export const GET_RAYON_FOR_MODAL = "GET_RAYON_FOR_MODAL";
export const GET_LOCALITY_CATEGORY_ALL = "GET_LOCALITY_CATEGORY_ALL";
export const GET_ALL_IDENTIFICATION_DOCUMENTS = "GET_ALL_IDENTIFICATION_DOCUMENTS";
export const GET_IDENTIFICATION_DOCUMENT_BY_ID = "GET_IDENTIFICATION_DOCUMENT_BY_ID";
export const GET_ALL_BOAT_TYPES = "GET_ALL_BOAT_TYPES";
export const GET_BOAT_TYPE_BY_ID = "GET_BOAT_TYPE_BY_ID";

export const GET_MED_CONDITION = "GET_MED_CONDITION";
export const GET_MED_CONDITIONS_ALL = "GET_MED_CONDITIONS_ALL";
export const GET_TRAINING_DOC_TYPES_ALL = "GET_TRAINING_DOC_TYPES_ALL";
export const GET_TRAINING_DOC_TYPE = "GET_TRAINING_DOC_TYPE";
export const GET_ENGINE_TYPES_ALL = "GET_ENGINE_TYPES_ALL";
export const GET_ENGINE_TYPE = "GET_ENGINE_TYPE";
export const GET_BOAT_BODY_MATERIAL_ALL = "GET_BOAT_BODY_MATERIAL_ALL";
export const GET_BOAT_BODY_MATERIAL = "GET_BOAT_BODY_MATERIAL";
export const GET_TRAINING_EXAM_TYPES_ALL = "GET_TRAINING_EXAM_TYPES_ALL";

export const GET_ALL_KINDS_BOATS = "GET_ALL_KINDS_BOATS";
export const GET_KIND_BOAT_BY_ID = "GET_KIND_BOAT_BY_ID";
export const GET_ACCOUNT_MANAGEMENT_ALL = "GET_ACCOUNT_MANAGEMENT_ALL";
export const UPDATE_SELECTS_DEPENDING_DEPARTMENT = "UPDATE_SELECTS_DEPENDING_DEPARTMENT";
export const GET_ROLES_ALL = "GET_ROLES_ALL";
export const GET_ACCOUNT_MANAGEMENT = "GET_ACCOUNT_MANAGEMENT";
export const GET_ACCOUNT_MANAGEMENT_EDIT_ERROR = "GET_ACCOUNT_MANAGEMENT_EDIT_ERROR";
export const GET_ACCOUNT_MANAGEMENT_CREATE_ERROR = "GET_ACCOUNT_MANAGEMENT_CREATE_ERROR";
export const GET_USER_INFO = "GET_USER_INFO";
export const DELETE_USER_INFO = "DELETE_USER_INFO";
export const GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR = "GET_ACCOUNT_MANAGEMENT_UPDATE_ERROR";
export const GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR = "GET_ACCOUNT_MANAGEMENT_BLOCK_ERROR";
export const GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR = "GET_ACCOUNT_MANAGEMENT_UNBLOCK_ERROR";
export const GET_AVAILABLE_ROLES = "GET_AVAILABLE_ROLES";
export const GET_AUDIT_SECURITY_ALL = "GET_AUDIT_SECURITY_ALL";

export const SET_SEARCH_PARAMS_AUDIT_ACTIONS_SYSTEM = "SET_SEARCH_PARAMS_AUDIT_ACTIONS_SYSTEM";
export const GET_DATA_AUDIT_ACTIONS_SYSTEM = "GET_DATA_AUDIT_ACTIONS_SYSTEM";
export const GET_USER_HISTORY = "GET_USER_HISTORY";
export const CLEAR_AUDIT_ACTIONS_SYSTEM = "CLEAR_AUDIT_ACTIONS_SYSTEM";

export const GET_MENU_CHAPTERS_ALL = "GET_MENU_CHAPTERS_ALL";
export const GET_CHAPTERS_BY_ROLE = "GET_CHAPTERS_BY_ROLE";
export const GET_CHAPTERS_BY_USER_ID = "GET_CHAPTERS_BY_USER_ID";
export const GET_MENU_ACTIONS_ALL = "GET_MENU_ACTIONS_ALL";
export const GET_ACTION_BY_CHAPTER_PRIV_ID = "GET_ACTION_BY_CHAPTER_PRIV_ID";
export const GET_AVAILABLE_ACTION_BY_CHAPTER_PRIV_ID = "GET_AVAILABLE_ACTION_BY_CHAPTER_PRIV_ID";

export const GET_MENU_STRUCT_BY_USER_ID = "GET_MENU_STRUCT_BY_USER_ID";
export const GET_MENU_NAMES = "GET_MENU_NAMES";
export const GET_SORTER_MENU_NAMES = "GET_SORTER_MENU_NAMES";
export const TOGGLE_BURGER_STATE = "TOGGLE_BURGER_STATE";
export const GET_PATTERN = "GET_PATTERN";
export const POST_PATTERN = "POST_PATTERN";
export const CLEAR_PATTERN = "CLEAR_PATTERN";

export const GET_INFO_BY_PERSONAL_NUM = "GET_INFO_BY_PERSONAL_NUM";
export const GET_INFO_BY_PERSONAL_NUM_AGENT = "GET_INFO_BY_PERSONAL_NUM_AGENT";
export const STATUS_INFO_BY_PERSONAL_NUM = "STATUS_INFO_BY_PERSONAL_NUM";
export const LOADING_INFO_BY_PERSONAL_NUM = "LOADING_INFO_BY_PERSONAL_NUM";
export const ERROR_INFO_BY_PERSONAL_NUM = "ERROR_INFO_BY_PERSONAL_NUM";
export const SIGN_STRING_ERROR = "SIGN_STRING_ERROR";
export const SET_INTERESTED_USER_DATA = "SET_INTERESTED_USER_DATA";
export const GET_RAYON_DATA = "GET_RAYON_DATA";
export const GET_RAYON_BY_AGENT_DATA = "GET_RAYON_BY_AGENT_DATA";
export const GET_GOROD_DATA = "GET_GOROD_DATA";
export const GET_GOROD_BY_AGENT_DATA = "GET_GOROD_BY_AGENT_DATA";

export const GET_COUNTRIES = "GET_COUNTRIES";
export const SET_SEARCH_PARAMS_COUNTRIES = "SET_SEARCH_PARAMS_COUNTRIES";
export const RESET_COUNTRY = "RESET_COUNTRY";
export const GET_COUNTRY = "GET_COUNTRY";
export const GET_COUNTRIES_ERROR = "GET_COUNTRIES_ERROR";
export const GET_COUNTRIES_NO_ERROR = "GET_COUNTRIES_NO_ERROR";
export const CHANGE_COUNTRIES_IS_SAVE = "CHANGE_COUNTRIES_IS_SAVE";
export const GET_ALL_AUDIT_SECURITY_EVENTS = "GET_ALL_AUDIT_SECURITY_EVENTS";
export const GET_GIMS_SUB_LEVELS = "GET_GIMS_SUB_LEVELS";

export const GET_ORGANIZATIONS = "GET_ORGANIZATIONS";
export const SET_SEARCH_PARAMS_ORGANIZATIONS = "SET_SEARCH_PARAMS_ORGANIZATIONS";
export const RESET_ORGANIZATION = "RESET_ORGANIZATION";
export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const CREATE_ORGANIZATIONS_ERROR = "CREATE_ORGANIZATIONS_ERROR";
export const CREATE_ORGANIZATIONS_NO_ERROR = "CREATE_ORGANIZATIONS_NO_ERROR";
export const CHANGE_ORGANIZATIONS_IS_SAVE = "CHANGE_ORGANIZATIONS_IS_SAVE";

export const SAVE_POSITION_NO_ERROR = "SAVE_POSITION_NO_ERROR";
export const SAVE_POSITION_ERROR = "SAVE_POSITION_ERROR";
export const CLEAR_POSITION = "CLEAR_POSITION";
